// pt-BR of the account security tab (decision D30); complete for every key of en-security.ts (checked by the type).
import type { enSecurity } from "./en-security.ts";

export const ptBRSecurity: Record<keyof typeof enSecurity, string> = {
  "settings.tab.security": "Segurança",
  "security.mfa.title": "Autenticação em dois fatores",
  "security.mfa.intro": "Sua conta é protegida por um aplicativo autenticador. Para levá-la a um novo celular ou aplicativo, gere uma nova chave aqui com sua senha e um código atual.",
  "security.mfa.notEnabled": "A autenticação em dois fatores não está ativada na sua conta.",
  "security.mfa.lostHint": "Perdeu o autenticador? Peça ao operador da plataforma para redefini-lo; depois entre com e-mail e senha e configure um novo aplicativo.",
  "security.mfa.regenerate": "Gerar nova autenticação em dois fatores",
  "security.mfa.step1Title": "Passo 1 de 3 — Confirme que é você",
  "security.mfa.currentCode": "Código atual",
  "security.mfa.currentCodeHint": "O código de 6 dígitos que o seu autenticador atual mostra agora.",
  "security.mfa.continue": "Continuar",
  "security.mfa.step2Title": "Passo 2 de 3 — Adicione a nova chave",
  "security.mfa.step2Body": "Adicione uma nova conta no seu aplicativo autenticador com esta chave de configuração. O aplicativo atual continua valendo até você confirmar.",
  "security.mfa.expiresAt": "Confirme esta chave até {time}; depois disso, comece de novo.",
  "security.mfa.added": "Já adicionei",
  "security.mfa.step3Title": "Passo 3 de 3 — Confirme o novo aplicativo",
  "security.mfa.newCode": "Código do novo aplicativo",
  "security.mfa.newCodeHint": "Se um código for recusado logo após o passo 1, aguarde o próximo código e tente de novo.",
  "security.mfa.confirm": "Confirmar novo autenticador",
  "security.mfa.invalidCredentials": "Senha ou código de verificação inválidos.",
  "security.mfa.invalidCode": "Código de verificação inválido.",
  "security.mfa.rateLimited": "Muitas tentativas. Aguarde alguns minutos e tente de novo.",
  "security.mfa.verifySession": "Primeiro verifique esta sessão com seu código atual: saia e entre de novo.",
  "security.mfa.expired": "A nova chave expirou antes de ser confirmada. Comece de novo.",
  "security.mfa.successTitle": "Autenticação em dois fatores renovada",
  "security.mfa.successBody": "A partir de agora use só o novo aplicativo: o antigo não funciona mais. Todas as outras sessões da sua conta foram encerradas; entre de novo nelas com um código do novo aplicativo.",
};
